/* js/components/App.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	check_outros,
	create_component,
	create_in_transition,
	create_out_transition,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import HomePage from '../pages/HomePage.svelte';
import ParcoursPage from '../pages/ParcoursPage.svelte';
import HaltePage from '../pages/HaltePage.svelte';
import EnCheminPage from '../pages/EnCheminPage.svelte';
import NotFoundPage from '../pages/NotFoundPage.svelte';
import AboutPage from '../pages/AboutPage.svelte';
import EventsPage from '../pages/EventsPage.svelte';
import ParcoursMenuPage from '../pages/ParcoursMenuPage.svelte';
import ConstellationMapPage from '../pages/ConstellationMapPage.svelte';
import NotificationDisplay from './NotificationDisplay.svelte';
import ConstellationPage from '../pages/ConstellationPage.svelte';
import Splash from './Splash.svelte';
import { Config } from '../config';
import { appRouter } from '../appRouter.js';
import { onMount } from 'svelte';
import { db } from '../Db.js';
import { runningOnMobileDevice } from '../utils';
import { HalteParentType } from '../HalteParentType';
import { cubicInOut } from 'svelte/easing';

function create_if_block_1(ctx) {
	let splash;
	let current;
	splash = new Splash({});

	return {
		c() {
			create_component(splash.$$.fragment);
		},
		m(target, anchor) {
			mount_component(splash, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(splash.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(splash.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(splash, detaching);
		}
	};
}

// (211:4) {:else}
function create_else_block(ctx) {
	let notificationdisplay;
	let t;
	let previous_key = /*page*/ ctx[0];
	let key_block_anchor;
	let current;
	notificationdisplay = new NotificationDisplay({});
	let key_block = create_key_block(ctx);

	return {
		c() {
			create_component(notificationdisplay.$$.fragment);
			t = space();
			key_block.c();
			key_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(notificationdisplay, target, anchor);
			insert(target, t, anchor);
			key_block.m(target, anchor);
			insert(target, key_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*page*/ 1 && safe_not_equal(previous_key, previous_key = /*page*/ ctx[0])) {
				group_outros();
				transition_out(key_block, 1, 1, noop);
				check_outros();
				key_block = create_key_block(ctx);
				key_block.c();
				transition_in(key_block);
				key_block.m(key_block_anchor.parentNode, key_block_anchor);
			} else {
				key_block.p(ctx, dirty);
			}
		},
		i(local) {
			if (current) return;
			transition_in(notificationdisplay.$$.fragment, local);
			transition_in(key_block);
			current = true;
		},
		o(local) {
			transition_out(notificationdisplay.$$.fragment, local);
			transition_out(key_block);
			current = false;
		},
		d(detaching) {
			destroy_component(notificationdisplay, detaching);
			if (detaching) detach(t);
			if (detaching) detach(key_block_anchor);
			key_block.d(detaching);
		}
	};
}

// (209:4) {#if !dbIsReady}
function create_if_block(ctx) {
	let h1;

	return {
		c() {
			h1 = element("h1");
			h1.textContent = "loading...";
		},
		m(target, anchor) {
			insert(target, h1, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(h1);
		}
	};
}

// (213:8) {#key page}
function create_key_block(ctx) {
	let div;
	let switch_instance;
	let div_intro;
	let div_outro;
	let current;
	let mounted;
	let dispose;
	var switch_value = /*page*/ ctx[0];

	function switch_props(ctx) {
		return { props: { params: /*params*/ ctx[1] } };
	}

	if (switch_value) {
		switch_instance = new switch_value(switch_props(ctx));
	}

	return {
		c() {
			div = element("div");
			if (switch_instance) create_component(switch_instance.$$.fragment);
			attr(div, "class", "full-height svelte-4qygyg");
		},
		m(target, anchor) {
			insert(target, div, anchor);

			if (switch_instance) {
				mount_component(switch_instance, div, null);
			}

			current = true;

			if (!mounted) {
				dispose = [
					listen(div, "introstart", onIntroStart),
					listen(div, "introend", onIntroEnd),
					listen(div, "outrostart", onOutroStart),
					listen(div, "outroend", onOutroEnd)
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			const switch_instance_changes = {};
			if (dirty & /*params*/ 2) switch_instance_changes.params = /*params*/ ctx[1];

			if (switch_value !== (switch_value = /*page*/ ctx[0])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = new switch_value(switch_props(ctx));
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, div, null);
				} else {
					switch_instance = null;
				}
			} else if (switch_value) {
				switch_instance.$set(switch_instance_changes);
			}
		},
		i(local) {
			if (current) return;
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);

			add_render_callback(() => {
				if (div_outro) div_outro.end(1);
				div_intro = create_in_transition(div, /*transitionIn*/ ctx[4], {});
				div_intro.start();
			});

			current = true;
		},
		o(local) {
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			if (div_intro) div_intro.invalidate();
			div_outro = create_out_transition(div, /*transitionOut*/ ctx[5], {});
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (switch_instance) destroy_component(switch_instance);
			if (detaching && div_outro) div_outro.end();
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let show_if = /*showSplash*/ ctx[3] && runningOnMobileDevice();
	let t;
	let current_block_type_index;
	let if_block1;
	let current;
	let if_block0 = show_if && create_if_block_1(ctx);
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (!/*dbIsReady*/ ctx[2]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t = space();
			if_block1.c();
			attr(div, "class", "container");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append(div, t);
			if_blocks[current_block_type_index].m(div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*showSplash*/ 8) show_if = /*showSplash*/ ctx[3] && runningOnMobileDevice();

			if (show_if) {
				if (if_block0) {
					if (dirty & /*showSplash*/ 8) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block1 = if_blocks[current_block_type_index];

				if (!if_block1) {
					if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block1.c();
				} else {
					if_block1.p(ctx, dirty);
				}

				transition_in(if_block1, 1);
				if_block1.m(div, null);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if_blocks[current_block_type_index].d();
		}
	};
}

let duration = 300;
let delay = 320;

function onIntroStart() {
	
} // console.log("intro start");

function onIntroEnd() {
	
} // console.log("intro stop");

function onOutroStart() {
	const top = `-${window.scrollY}px`;

	// console.log("top", top, window.scrollY);
	document.body.style.top = top;

	document.body.style.position = 'fixed';
} // console.log("outro start");

function onOutroEnd() {
	window.scrollTo({ top: 0 });
	document.body.style.position = '';
} // console.log("outro stop");

function instance($$self, $$props, $$invalidate) {
	let page = null;
	let params;
	let dbIsReady = false;
	let showSplash = true;

	const transitionIn = () => ({
		duration,
		delay,
		easing: cubicInOut,
		css: t => `opacity: ${t}`
	});

	const transitionOut = () => ({
		duration,
		delay: 0,
		easing: cubicInOut,
		css: t => `opacity: ${t}`
	});

	onMount(async () => {
		setTimeout(
			() => {
				// console.log("hide Splash");
				$$invalidate(3, showSplash = false);
			},
			Config.splash_screen_duration
		);

		await db.load();
		$$invalidate(2, dbIsReady = true);

		appRouter.addRoute('/', () => {
			$$invalidate(0, page = HomePage);
		});

		/////////////////
		// parcours handling
		appRouter.addRoute(
			'/parcours/:slug',
			(ctx, next) => {
				$$invalidate(1, params = ctx.params);
				next();
			},
			(ctx, next) => {
				if (db.isValidParcoursSlug(ctx.params.slug)) {
					$$invalidate(0, page = ParcoursPage);
				} else {
					$$invalidate(0, page = NotFoundPage);
				}
			}
		);

		appRouter.addRoute(
			'/qr/:parcoursId/:halteId',
			(ctx, next) => {
				$$invalidate(1, params = ctx.params);
				console.log("qr params", params);
				next();
			},
			(ctx, next) => {
				let redirect = db.redirectForParcoursIdAndHalteId(ctx.params.parcoursId, ctx.params.halteId);
				console.log("qr redirect ", redirect);

				if (redirect) {
					appRouter.redirect(redirect);
				} else {
					$$invalidate(0, page = NotFoundPage);
				}
			}
		);

		appRouter.addRoute(
			'/parcours/:parentSlug/halte/:halteSlug',
			(ctx, next) => {
				$$invalidate(1, params = ctx.params);
				$$invalidate(1, params.halteType = HalteParentType.parcours, params);
				next();
			},
			(ctx, next) => {
				if (db.isValidHalteParamsForParentType(ctx.params.parentSlug, ctx.params.halteSlug, params.halteType)) {
					$$invalidate(0, page = HaltePage);
				} else {
					$$invalidate(0, page = NotFoundPage);
				}
			}
		);

		appRouter.addRoute(
			'/parcours/:parcoursSlug/en_chemin/:halteSlug',
			(ctx, next) => {
				$$invalidate(1, params = ctx.params);
				next();
			},
			(ctx, next) => {
				if (db.isValidHalteParamsForParentType(ctx.params.parcoursSlug, ctx.params.halteSlug, HalteParentType.parcours)) {
					$$invalidate(0, page = EnCheminPage);
				} else {
					$$invalidate(0, page = NotFoundPage);
				}
			}
		);

		appRouter.addRoute('/parcours', () => {
			$$invalidate(0, page = ParcoursMenuPage);
		});

		/////////////////
		// constellation handling
		appRouter.addRoute(
			'/constellation/:slug',
			(ctx, next) => {
				$$invalidate(1, params = ctx.params);
				next();
			},
			(ctx, next) => {
				if (db.isValidConstellationSlug(ctx.params.slug)) {
					$$invalidate(0, page = ConstellationPage);
				} else {
					$$invalidate(0, page = NotFoundPage);
				}
			}
		);

		appRouter.addRoute(
			'/constellation/:constellationSlug/carte',
			(ctx, next) => {
				$$invalidate(1, params = ctx.params);
				next();
			},
			(ctx, next) => {
				if (db.isValidConstellationSlug(ctx.params.constellationSlug)) {
					$$invalidate(0, page = ConstellationMapPage);
				} else {
					$$invalidate(0, page = NotFoundPage);
				}
			}
		);

		appRouter.addRoute(
			'/constellation/:parentSlug/halte/:halteSlug',
			(ctx, next) => {
				$$invalidate(1, params = ctx.params);
				$$invalidate(1, params.halteType = HalteParentType.constellation, params);
				next();
			},
			(ctx, next) => {
				if (db.isValidHalteParamsForParentType(ctx.params.parentSlug, ctx.params.halteSlug, params.halteType)) {
					$$invalidate(0, page = HaltePage);
				} else {
					$$invalidate(0, page = NotFoundPage);
				}
			}
		);

		////////////////
		// single pages
		appRouter.addRoute('/a_propos', () => {
			$$invalidate(0, page = AboutPage);
		});

		appRouter.addRoute('/evenements', () => {
			$$invalidate(0, page = EventsPage);
		});

		appRouter.addRoute(
			'*',
			(ctx, next) => {
				$$invalidate(1, params = ctx.params);
				next();
			},
			() => $$invalidate(0, page = NotFoundPage)
		);

		const options = {
			click: true,
			popstate: true,
			dispatch: true,
			hashbang: false,
			decodeUrlComponents: true
		};

		appRouter.start(options);
	});

	return [page, params, dbIsReady, showSplash, transitionIn, transitionOut];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;